module.exports = __webpack_public_path__ + "static/img/cont43_10.407e7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_10.jpg
// module id = Nofi
// module chunks = 0